import { useUserData } from 'app/main/components';
import { ViewPageListTab } from 'app/main/components/page-layouts';
import type { ViewPageContentTabProps, ViewPageContentTabType } from 'app/main/components/page-layouts/view/ViewPage';

import LeaveListItem from '../LeaveListItem';

const tabs: ViewPageContentTabType[] = [
	{
		id: 'list',
		title: 'TAB_LIST',
		content: props => <ViewPageListTab {...props} id="leaveView" itemLayout={LeaveListItem} />
	}
];

export default tabs;
